import { API } from '../../../../api';
import { axiosInstance } from '../../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getZoneListEffectCancelToken = () => {};
export const getZoneListEffect = (data) => {
  getZoneListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetZoneSearch`,
    method: 'GET',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getZoneListEffectCancelToken = c;
    }),
  });
};

export const saveUpdateZoneEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/SaveZoneDetails`,
    method: 'POST',
    data,
  });
};

export const bindLocationZoneEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/SaveZoneLocation`,
    method: 'POST',
    data,
  });
};

export const deleteProcurementZoneEffects = (params) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/DeleteZone`,
    method: 'delete',
    data: params,
  });
};

export const deleteZoneLocationEffects = (params) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/DeleteZoneLocation`,
    method: 'delete',
    data: params,
  });
};

export const getZoneListSerchEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetZoneSearch`,
    method: 'GET',
    params: data,
  });
};
